import React, { useEffect, useState } from "react";

import FooterAreaTwo from "../components/FooterAreaTwo";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import DataSec from "../components/DataSec";

const DataSecPage = () => {
	let [active, setActive] = useState(true);
	useEffect(() => {
		setTimeout(function () {
			setActive(false);
		}, 2000);
	}, []);
	return (
		<>
			{/* Preloader */}
			{active === true && <Preloader />}

			{/* Header one */}
			<HeaderTwo showMenu={false} />

			{/* Breadcrumb */}
			{/* <Breadcrumb title={"Kontakt"} /> */}

			{/* Contact Area */}
			<DataSec />

			{/* Footer Area One */}
			<FooterAreaTwo />
		</>
	);
};

export default DataSecPage;
